import type { IPhaseInfo, NamedParams } from '@/engine/app/CasePhaseData/interfaces.ts';
import { action, makeObservable, observable } from 'mobx';

export class PhaseInfo implements IPhaseInfo {
  public readonly id: string;

  public readonly name: string;

  @observable
  private readonly _params: NamedParams = new Map<string, number>();

  public constructor(id: string, name: string, params?: NamedParams) {
    this.id = id;
    this.name = name;
    this._params = params || new Map<string, number>();
    makeObservable(this);
  }

  public getParamsIterator(): IterableIterator<[string, number]> {
    return this._params.entries();
  }

  public getParam(name: string): number | undefined {
    return this._params.get(name);
  }

  @action
  public setParam(name: string, value: number): void {
    this._params.set(name, value);
  }
}
